/**
 * The call-off list's Export menu: the same pair as the Stock Planning export —
 * a styled Excel workbook, or a CSV — of exactly what the list is showing.
 */
import { Button } from '../../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../ui/dropdown-menu';
import { Download, FileSpreadsheet, FileText, Loader2 } from 'lucide-react';
import type { ExportFormat } from './useCallOffExport';

interface CallOffExportMenuProps {
  onExport: (format: ExportFormat) => void;
  /** Nothing to export (no rows, or the list is still loading). */
  disabled: boolean;
  exporting: boolean;
}

export default function CallOffExportMenu({ onExport, disabled, exporting }: CallOffExportMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2" disabled={disabled || exporting}>
          {exporting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
          Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuItem disabled={exporting} onClick={() => onExport('xlsx')}>
          <FileSpreadsheet className="h-4 w-4 mr-2 text-green-700" />
          Download Excel
        </DropdownMenuItem>
        <DropdownMenuItem disabled={exporting} onClick={() => onExport('csv')}>
          <FileText className="h-4 w-4 mr-2 text-blue-700" />
          Download CSV
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
